import React from 'react';

export default function Loader() {
  return (
    <div className="loader_Wrapper">
      <div class="leftEye"></div>
      <div class="rightEye"></div>
      <div class="mouth"></div>
    </div>
  );
}
